import React from "react";
import { PageErrorContext } from "@src/context/pageErrorContext";
import { trackError } from "@src/utils/userActivityTracker";
import ErrorPage from "../layout/ErrorPage";

class ResetableErrorBoundary extends React.Component {
  static contextType = PageErrorContext;

  // This only handles errors that occur during UI rendering, lifecycle methods, or constructors of components.
  // It will NOT catch errors thrown by React Router loaders or actions.
  componentDidCatch(error, info) {
    this.context.updateError(error);
    this.logErrorToActivityService(error, info.componentStack);
  }

  logErrorToActivityService(error, componentStack) {
    console.error(error, { componentStack });
    trackError(error, undefined, {
      componentStack,
      catchingElement: "ResetableErrorBoundary",
    });
  }

  render() {
    if (this.context.hasError) {
      console.log(
        "Resettable Error boundary - ",
        this.context.errorMessage || this.props.error?.message,
      );
      return <ErrorPage />;
    }

    return this.props.children;
  }
}

export default ResetableErrorBoundary;
